<template>
  <v-layout column>
    <vbt-search
      v-model="searchData"
      :items="searchFieldsConfig"
      @reset="onResetSearch"
      @search="onSearch"
    />

    <vbt-content-box
      :loading="isLoading"
      :loading-error="loadingError"
      :no-content="noContent"
      :go-back-btn="goBack"
      title="Information"
    >
      <template #toolbar>
        <v-btn
          small
          color="warning"
          @click="syncMachines"
        >
          Sync
        </v-btn>
      </template>
      <vbt-table
        :items="machines"
        :headers="headers"
      >
        <template #state="{ item: { state } }">
          <kernel-status-badge :status="state">
            {{ state }}
          </kernel-status-badge>
        </template>
      </vbt-table>

      <vbt-pagination
        v-model="pageNum"
        :items-count="pagedItemsCount"
      />
    </vbt-content-box>
  </v-layout>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import { useDataLoading, usePagination, useSearch } from '@mixins/factories';

import { wrapToLoadingFn } from '@helpers';

import { namespace as EnumsNamespace } from '@store/modules/enums.types';
import { namespace as LocationsNamespace } from '@store/modules/locations.types';

import { namespace as MachinesNamespace, ActionTypes as MachinesActionTypes } from '../store.types';

import MachinesApiService from '../_services/machines.api.service';

const dataLoadingOptions = { getterName: MachinesActionTypes.GET_MACHINES, contentName: 'machines' };
const paginationOptions = { contentName: 'machines' };
const searchOptions = {
  initialSearchDataStates: [
    'state', 'name',
  ],
};

const headers = Object.freeze([
  { text: 'Name', value: 'name' },
  { text: 'Category', value: 'category' },
  { text: 'State', value: 'state' },
]);

export default {
  name: 'KernelMachines',
  mixins: [
    useDataLoading(dataLoadingOptions),
    usePagination(paginationOptions),
    useSearch(searchOptions),
  ],
  data: () => ({ headers }),
  computed: {
    ...mapState(MachinesNamespace, ['machines']),
    ...mapState(LocationsNamespace, ['suffix']),
    ...mapState(EnumsNamespace, {
      machineStates: ({ enums: { machineState: enums } }) => (enums || [])
        .map(({ value }) => value),
    }),
    ...mapGetters(EnumsNamespace, ['machinesStateEnumByValue']),
    searchFieldsConfig() {
      return [
        { value: 'name', label: 'Name', type: 'text' },
        {
          value: 'state',
          items: this.machineStates,
          label: 'State',
          type: 'select',
        },
      ];
    },
  },
  watch: {
    suffix: '$_refreshData',
  },
  methods: {
    ...mapActions(MachinesNamespace, [MachinesActionTypes.GET_MACHINES]),
    wrapToLoadingFn,
    syncMachines() {
      this.$VBlackerTheme.alert.warning({
        text: 'Sync machines?',
      }, () => this.wrapToLoadingFn({
        req: MachinesApiService.syncMachines.bind({}, { suffix: this.suffix }),
        onSuccess: () => {
          this.$VBlackerTheme.notification.success('Machines successfully synced');
          this.$_refreshData();
        },
      }));
    },
  },
};
</script>
